import { useState } from "react";
import * as S from "./style";
import { useLocation, NavLink } from "react-router-dom";
import { useAuth } from "context/AuthContext";
//Component
import LogoMundialCrop from "../../assets/logoCROP.png";
import Logout from "../../components/Logout";
import { useOpenModal } from "../../hooks/useOpenModal";
import { useOpenSidebar } from "../../hooks/useOpenSidebar";
//icons
import {
  SignOut,
  ChartBar,
  Truck,
  Screwdriver,
  UsersThree,
  ShoppingCart,
  User,
  Eyeglasses,
  CircleHalfTilt,
  Gift,
  ArrowLeft,
  ArrowRight,
  CashRegister,
  SealPercent,
  Package,
  NotePencil,
  ChartLineDown,
  Bank,
  CaretUp,
  CaretDown,
  CreditCard,
  ArrowsCounterClockwise,
  ReceiptX,
} from "@phosphor-icons/react";

export default function Aside() {
  const location = useLocation();
  const iconSize = 24;
  const UserAuthenticated = useAuth();
  const isAdmin = UserAuthenticated?.user?.is_admin;
  const { isOpenModal, toggleModalVisibility } = useOpenModal();
  const { isOpenSidebar, toggleSidebar } = useOpenSidebar();
  const [isSubMenuVisible, setSubMenuVisible] = useState(false);

  const menuItemsTop = [
    { visible: isAdmin, icon: <ChartBar size={iconSize} />, title: "Dashboard", path: "/dashboard" },
    { visible: true, icon: <Package size={iconSize} />, title: "Estoque", path: "/estoque", sub_path: '/estoqueDeLenteLab' },
    { visible: true, icon: <Eyeglasses size={iconSize} />, title: "Armação", path: "/armacao" },
    { visible: true, icon: <CircleHalfTilt size={iconSize} />, title: "Lente", path: "/lente", sub_path: '/estoqueDeLente' },
    { visible: true, icon: <Gift size={iconSize} />, title: "Acessório", path: "/acessorio" },
    { visible: true, icon: <Screwdriver size={iconSize} />, title: "Serviço", path: "/servico" },
    { visible: true, icon: <UsersThree size={iconSize} />, title: "Cliente", path: "/cliente" },
    { visible: true, icon: <SealPercent size={iconSize} />, title: "Promoção", path: "/promocao" },
    { visible: true, icon: <Truck size={iconSize} />, title: "Fornecedor", path: "/fornecedor" },
  ];

  const menuItemsFinancial = [
    { visible: true, icon: <CreditCard size={iconSize} />, title: "Cartão", path: "/cartao" },
    { visible: true, icon: <ChartLineDown size={iconSize} />, title: "Saída", path: "/saida" },
    { visible: true, icon: <NotePencil size={iconSize} />, title: "Ordem de Serviço", path: "/ordem-de-servico" },
    { visible: true, icon: <CashRegister size={iconSize} />, title: "Venda", path: "/venda" },
    { visible: true, icon: <ReceiptX size={iconSize} />, title: "Cancelamento", path: "/cancelamento" },
    { visible: true, icon: <ArrowsCounterClockwise size={iconSize} />, title: "Fluxo de Caixa", path: "/fluxo-de-caixa" },
    // { visible: true, icon: <ShoppingCart size={iconSize} />, title: "Nova venda", path: "/novaVenda" },
  ];

  const menuItemsBottom = [
    { icon: <User size={iconSize} />, title: "Usuário", path: "/usuario" },
  ];

  const menuActive = !isSubMenuVisible && menuItemsFinancial.some((menu) => location.pathname === menu.path);

  const closeSidebarIfOpen = () => {
    if (isOpenSidebar) {
      toggleSidebar(); // apenas fecha se estiver aberto
    }
  };
  return (
    <S.Container isOpen={isOpenSidebar}>

      <S.HamburgerButton onClick={toggleSidebar}>
        {isOpenSidebar ? (
          <ArrowLeft size={iconSize} />
        ) : (
          <ArrowRight size={iconSize} />
        )}
      </S.HamburgerButton>

      <S.Content>
        <S.ContentImage>
          <S.Image src={LogoMundialCrop} alt="Logo Óticas Mundial" />
        </S.ContentImage>
        <S.ContentMenu>
          <S.Divider>
            {menuItemsTop.map((menu, index) => (
              menu.visible ?
                <NavLink
                  onClick={closeSidebarIfOpen}
                  to={menu.path}
                  style={{ color: "black", textDecoration: "none" }}
                  key={index}
                >
                  <S.Menu
                    onMouseEnter={() => !isOpenSidebar}
                    className={location.pathname === menu.path || location.pathname === menu.sub_path ? "active" : ""}
                  >
                    {menu.icon}
                    {isOpenSidebar && <S.TitleMenu>{menu.title}</S.TitleMenu>}
                  </S.Menu>
                </NavLink>
                : null
            ))}
          </S.Divider>

          <S.Divider>
            <S.Menu
              onMouseEnter={() => !isOpenSidebar}
              onClick={() => setSubMenuVisible(!isSubMenuVisible)}
              className={menuActive ? 'active' : ''}
            >
              <S.ContentDiv>
                <Bank size={iconSize} />
                {
                  isSubMenuVisible ?
                    <CaretUp size={12} />
                    :
                    <CaretDown size={12} />
                }
              </S.ContentDiv>
              {isOpenSidebar && <S.TitleMenu>{'Financeiro'}</S.TitleMenu>}
            </S.Menu>

            <S.SubMenuWrapper
              className={isSubMenuVisible ? 'visible' : ''}
            >
              {menuItemsFinancial.map((menu, index) => (
                menu.visible ?
                  <NavLink
                    onClick={closeSidebarIfOpen}
                    to={menu.path}
                    style={{ color: "black", textDecoration: "none" }}
                    key={index}
                  >
                    <S.Menu
                      onMouseEnter={() => !isOpenSidebar}
                      className={location.pathname === menu.path ? "active" : ""}
                    >
                      {menu.icon}
                      {isOpenSidebar && <S.TitleMenu>{menu.title}</S.TitleMenu>}
                    </S.Menu>
                  </NavLink>
                  : null
              ))}
            </S.SubMenuWrapper>
          </S.Divider>

          <S.Divider>
            {/* Borda entre as seções */}
            {menuItemsBottom.map((menu, index) => (
              <NavLink
                onClick={closeSidebarIfOpen}
                to={menu.path}
                style={{ color: "black", textDecoration: "none" }}
                key={index}
              >
                <S.Menu
                  onMouseEnter={() => !isOpenSidebar}
                  className={location.pathname === menu.path ? "active" : ""}
                >
                  {menu.icon}
                  {isOpenSidebar && <S.TitleMenu>{menu.title}</S.TitleMenu>}
                </S.Menu>
              </NavLink>
            ))}

            <S.Menu
              onMouseEnter={() => !isOpenSidebar}
              onClick={toggleModalVisibility}
            >
              <SignOut size={iconSize} />
              {isOpenSidebar && <S.TitleMenu>Sair</S.TitleMenu>}
            </S.Menu>
          </S.Divider>
        </S.ContentMenu>
      </S.Content>

      <S.Footer>
        {isOpenSidebar && (
          <S.InforUser>
            <p>{UserAuthenticated.user?.first_name}</p>
            <span>{UserAuthenticated.user?.email}</span>
          </S.InforUser>
        )}
        <S.User onClick={toggleSidebar}>
          <S.LogoUser>
            {isOpenSidebar ? (
              <ArrowLeft size={iconSize} />
            ) : (
              <ArrowRight size={iconSize} />
            )}
          </S.LogoUser>
        </S.User>
      </S.Footer>

      {isOpenModal && (
        <Logout isOpen={isOpenModal} setModalOpen={toggleModalVisibility} />
      )}
    </S.Container>
  );
}
